import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAsyncAction } from '../hooks/useAsyncAction';
import AuthCard from '../components/AuthCard';
import { authStyles } from '../styles/authStyles';

export default function ForgotPasswordPage() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const { loading, error, run } = useAsyncAction();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await run(async () => {
      await forgotPassword(email);
      setSubmitted(true);
    });
  };

  return (
    <AuthCard>
      {submitted ? (
        <>
          <h1 style={authStyles.heading}>Check your email</h1>
          <p style={authStyles.sub}>
            If an account with that email exists, we've sent a password reset link.
            It expires in 1 hour.
          </p>
          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <Link to="/login" style={authStyles.link}>Back to log in</Link>
          </div>
        </>
      ) : (
        <>
          <h1 style={authStyles.heading}>Reset your password</h1>
          <p style={authStyles.sub}>
            Enter your email and we'll send you a reset link.
          </p>

          {error && <div style={authStyles.error}>{error}</div>}

          <form onSubmit={handleSubmit} style={authStyles.form}>
            <label style={authStyles.label}>
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={authStyles.input}
                required
                autoComplete="email"
                autoFocus
              />
            </label>
            <button type="submit" disabled={loading} style={authStyles.button}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>

          <div style={authStyles.footer}>
            <Link to="/login" style={authStyles.link}>Back to log in</Link>
          </div>
        </>
      )}
    </AuthCard>
  );
}
